module.exports = __webpack_public_path__ + "static/media/Logo-Mobile.1ccd443c.png";